import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { SuppliesModel } from 'src/app/models/SuppliesModel';
import { SuppliesService } from "../../services/SuppliesService";
import { MatDialog } from '@angular/material/dialog';
import { LocalStorageService } from 'ngx-webstorage';
import { ClassificationCModel } from 'src/app/models/ClassificationCModel';
import { ClassificationCService } from 'src/app/services/ClassificationCService';
import {formatDate} from '@angular/common';
import Swal from 'sweetalert2';
import { CodessearchComponent } from '../codessearch/codessearch.component';


@Component({
  selector: 'app-codes',
  templateUrl: './codes.component.html',
  styleUrls: ['./codes.component.css']
})
export class CodesComponent implements OnInit {
  supCode = '';
  supName = '';
  supAddress = '';
  supNotes ='';
  supGroup = '';
  compCode = '1';
  userID = 'sa';
  clasCCode='';
  clasCName ='';
  modifaiedDate = '2021-01-01';
  classificationCList: ClassificationCModel[] =[];


  constructor(public suppliesService: SuppliesService,
              public supplies: SuppliesModel,
              public suppSelectedData: SuppliesModel,
              public classificationCService: ClassificationCService,
              public classificationCModel: ClassificationCModel,
              public storage: LocalStorageService,
              private dialogref: MatDialog,
              ) { }

  ngOnInit(): void {
    this.retriveClassificationLookupTop();
    this.supCode = this.storage.retrieve('stgPatientCode');
    this.retriveSupplies();
  }

  retriveSupplies(){
    this.suppliesService.getsupplies(this.supCode,this.compCode).subscribe((data: SuppliesModel) => {
      this.supName = data.supName;
      this.supAddress = data.supAddress;
      this.supNotes = data.supNotes;
      this.supGroup = data.supGroup;
      this.compCode = data.compCode;
      this.userID = data.userID;
      this.modifaiedDate = data.modifaiedDate;


    })
  }
  deleteSupplies() {
    this.suppliesService.delSupplies(this.supCode, this.compCode).subscribe((data: SuppliesModel) => {
        this.supCode = data.supCode;
        this.supName = data.supName;
        this.supAddress = data.supAddress;
        this.supNotes = data.supNotes;
        this.supGroup = data.supGroup;
        this.compCode = data.compCode;
        this.userID = data.userID;
        this.modifaiedDate = data.modifaiedDate;
      }
    );
  }

  NewData() {
    this.storage.store('stgPatientCode', '');
    this.supCode = '';
    this.supName = '';
    this.supAddress = '';
    this.supNotes ='';
    this.supGroup = '';
    this.compCode = '1';
    this.userID = '';
    this.modifaiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.compCode = '1';
  }

  submitSupplies() {
    this.supplies.supCode = this.supCode;
    this.supplies.supName = this.supName;
    this.supplies.supAddress = this.supAddress;
    this.supplies.supNotes = this.supNotes;
    this.supplies.supGroup = this.supGroup;
    this.supplies.compCode =  this.storage.retrieve('stgcompCode');
    this.supplies.userID = this.storage.retrieve('stguserId');
    this.supplies.modifaiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');

    this.suppliesService.Addsupplies(this.supplies).subscribe(data => {
      console.log(data.supCode);
     this.mesgSave();
    },
      error => { alert(error); }
    );;
  }
  mesgDelete() {

    Swal({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(() => {
        this.deleteSupplies();
        Swal('Deleted!', 'Your record has been deleted.', 'success');

      },
      function (dismiss) {
        if (dismiss === 'cancel') {
          Swal('Cancelled', 'Your record is safe :)', 'error');
        }
      }
    );
  }
  openDialog(){
    const dialogRef = this.dialogref.open(CodessearchComponent,
      {
        data: {
          dataKey: this.suppSelectedData
        },
        width: '80%'

    });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
       dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.supCode = result.supCode;
        this.supName = result.supName;
        this.supAddress = result.supAddress;
        this.supGroup = result.supGroup;
        this.supNotes = result.supNotes;
        this.compCode = result.compCode;
        this.userID = result.userID;
        this.modifaiedDate = result.modifaiedDate;
        this.retriveSupplies();
        dialogSubmitSubscription.unsubscribe();

      });
  }

  retriveClassificationLookupTop() {
    this.classificationCService
      .getClassificationCLookupTop(this.compCode)
      .subscribe((data: ClassificationCModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.classificationCList[i] = data[i];
        }
        console.log(data);
      });
  }
  mesgSave() {
    Swal({
    title: 'Your work has been saved',

    type: 'success',
    showConfirmButton: false,

    timer: 1500
    });
  }

}

